export const technicalSheet = {
	title: "Ficha técnica",
	modalDelete: {
		title: "Eliminar ficha técnica",
		text:
			"Al confirmar la acción usted elimina permanentemente la ficha técnica. ¿Desea continuar?",
		okText: "Sí, deseo eliminar la ficha técnica",
	},
	addInput: {
		columns: {
			inputName: "Insumo",
			count: "Cantidad",
			unitCostValue: "Costo unitario",
			totalCost: "Costo total",
			actions: "Acciones",
		},
		warnings: {
			withoutInput: "Seleccione un insumo",
			withoutQuantity: "Agregue una cantidad",
			alreadyExist:
				"El insumo ya existe en la lista de insumos, seleccione un insumo diferente.",
		},
		inputName: "Insumo",
		count: "Cantidad",
		loss: "Pérdida",
		value: "Precio de costo",
		price: "Precio",
		add: "Agregar",
	},
	editInput: {
		inputName: "Insumo",
		count: "Cantidad",
		loss: "Pérdida",
		value: "Precio de costo",
		price: "Precio",
		delete: "Eliminar",
	},
	header: {
		addButton: "Agregar Insumo",
		editButton: "Editar ficha técnica",
	},
	infoCard: {
		value: "Precio de venta",
		totalCost: "Costo total",
		cmv: "CMV %",
		profitMargin: "Margen de ganancia",
	},
	table: {
		columns: {
			inputName: "Insumo",
			count: "Cantidad",
			loss: "Pérdida",
			unitCostValue: "Costo unitario",
			yieldPercentage: "Rendimiento",
			unitCostWithYield: "Costo con rendimiento",
			totalCost: "Costo total",
			actions: "Acciones",
		},
	},
};
